<div class="public-layout">
    <app-progress-loader></app-progress-loader>
    <router-outlet></router-outlet>
</div>
